import React, { useEffect, useState } from 'react';
import { Alert, Button, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { accountOptionArray, contributionTypeArray, pacFrequencyList, radioColorSx } from 'store/constant';
// import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Stack } from '@mui/system';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import DeleteIcon from '@mui/icons-material/Delete';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';

const SwpInformation = ({ accountTypeId, swpRef, formAccountData, userId, setAccountSwpData, setFormAccountData, activeAccountStep, setActiveAccountStep, setActiveParentStep, setParentActiveAccountTypeId }) => {

    const today = new Date();
    const minDate = new Date();
    minDate.setDate(today.getDate() + 5);

    // Calculate the last date of the next month
    const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [filteredAccountDetails, setFilteredAccountDetails] = useState([]);
    const [transferDetails, setTransferDetails] = useState(formAccountData.transfer_details);
    const [swpDetails, setSwpDetails] = useState([...formAccountData.swp_details]);
    const [selectedBankAccountNumber, setSelectedBankAccountNumber] = useState('');
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [hideFormData, setHideFormData] = useState(false)

    const {
        register,
        handleSubmit,
        setValue,
        control,
        trigger,
        formState: { errors }
    } = useFormContext();

    React.useImperativeHandle(swpRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));

    const fetchBankingData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);

            if (response.data.length > 0) {
                setTransferDetails(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchSwpData = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-swp-info/${userId}`);

            setHideFormData(response.is_applicable)

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    ...response.data[0],
                }));

                let dataFilter = []

                if (response.data[0]) {
                    setSwpDetails(response.data);
                    dataFilter = response.data
                } else {
                    setSwpDetails([response.data]);
                    dataFilter = [response.data]
                }


                const defaultBankAccountNumber = dataFilter[0].bank_account_number;

                setSelectedBankAccountNumber(defaultBankAccountNumber)

                const filteredData = dataFilter.map((item) => ({
                    account_type_id: item.account_type_id,
                    bank_account_number: item.bank_account_number,
                    bank_currency: item.bank_currency,
                    bank_institution_number: item.bank_institution_number,
                    bank_name: item.bank_name,
                    bank_transit_number: item.bank_transit_number,
                    id: item.id,
                    user_id: item.user_id,
                    /* created_at: item.created_at,
                    updated_at: item.updated_at,
                    void_cheque_file: item.void_cheque_file */
                }));
                setFilteredAccountDetails(filteredData);

                setValue('swp_start_date', response.data[0].swp_start_date)
                setValue('swp_frequency', response.data[0].swp_frequency)
                setValue('swp_account_option', response.data[0].swp_account_option)
            }
        } catch (error) {
            // console.error(error.message);
        }
    }


    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                }));
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        let modifiedChildStep = activeAccountStep - 1

        // if (formAccountData.account_pac == 2 && formAccountData.account_eft == 2) {
        //     modifiedChildStep = 3
        // } else if (formAccountData.account_pac == 2) {
        //     modifiedChildStep = 4
        // }

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const handleTransferChange = (value, index, name) => {
        const updatedPolicies = [...swpDetails];
        updatedPolicies[0].swp_plan_investment_instruction[index][name] = value;
        setSwpDetails(updatedPolicies);
        setAccountSwpData((prevData => ({
            ...prevData,
            ...updatedPolicies
        })))
    };

    const removeSwpInstruction = async (index, id, swpId) => {

        if (id) {

            const result = await showConfirmSweetAlert({
                title: 'Remove Item?',
                text: 'Are you sure you want to remove this?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader()
                try {
                    const response = await axiosInstance.delete(`api/delete-swp-instruction/${id}/${swpId}`);
                    hideLoader()

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error(response.message);
                    }

                } catch (error) {
                    toast.error(error.message);
                }
            }

        } else {
            const updatedTransferDetails = [...swpDetails];
            updatedTransferDetails[0].swp_plan_investment_instruction.splice(index, 1);
            setSwpDetails(updatedTransferDetails);
        }
    }

    const addNewTemplate = () => {

        const updatedPolicies = [...swpDetails];
        updatedPolicies[0].swp_plan_investment_instruction.push({
            id: '',
            swp_pii_contribution_type: '',
            swp_pii_fund_number: '',
            swp_pii_fund_name: '',
            swp_pii_gross_amount: ''
        });
        setSwpDetails(updatedPolicies);
    };

    const handleBankAccountChange = (event) => {

        const bankAccountNumber = event.target.value;
        setSelectedBankAccountNumber(bankAccountNumber);

        const filteredData = transferDetails.filter(
            (detail) => detail.bank_account_number === bankAccountNumber
        );
        setFilteredAccountDetails(filteredData);

        setAccountSwpData((prevData => ({
            ...prevData,
            bank_account_number: filteredData[0].bank_account_number,
            bank_name: filteredData[0].bank_name,
            bank_transit_number: filteredData[0].bank_transit_number,
            bank_institution_number: filteredData[0].bank_institution_number,
        })))

    };

    const submitForm = async () => {

        showLoader()

        setFormAccountData(prevData => ({
            ...prevData,
            swp_plan_investment_instruction: swpDetails
        }));

        let endPoint = `api/save-user-swp-info`;

        let modifiedChildStep = 0;
        let activeParentStep = 2

        // because income sweep fixed NA so
        // let modifiedChildStep = activeAccountStep + 1;
        // if (formAccountData.account_income_sweep == 2) {
        //     modifiedChildStep = 7;
        // }

        const submitData = { ...swpDetails[0], ...filteredAccountDetails[0], login_id: formAccountData.login_id, accountTypeId: accountTypeId, user_id: userId ? userId : 0, parent_step: activeParentStep, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
                setActiveParentStep(activeParentStep) //to risk questionnaire
            }

        } catch (error) {
            // console.error(error)
        } finally {
            hideLoader()
        }
    }


    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchSwpData()
            await fetchAccountTypeInfoData()
            await fetchBankingData()
            hideLoader()

        } catch (error) {
            hideLoader()
        }
    }


    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <div className='container'>
            <form onSubmit={handleSubmit(submitForm)}>

                {hideFormData &&
                    <><div className='mt-3 width100'>
                        {swpDetails[0].swp_plan_investment_instruction?.map((item, index) => (
                            <React.Fragment key={index}>
                                {/* <Grid item xs={12}>
                        <Typography variant='h3' className='form-head-gray-title'>Systematic Withdrawal Plan Instruction #{index + 1}</Typography>
                    </Grid> */}

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    className='form-head-gray-title'
                                >
                                    <Grid item>
                                        <Typography component={'h3'}>Systematic Withdrawal Plan Instruction #{index + 1}</Typography>
                                    </Grid>

                                    <Grid item>
                                        <IconButton sx={{ p: "0 10px 0 0" }} disabled={index == 0} onClick={() => removeSwpInstruction(index, item.id, swpDetails[0].swp_id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} className='p-4'>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="contribution_type" className='font15px'>Contribute Type</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                id='contribution-type'
                                                name='swp_pii_contribution_type'
                                                value={item.swp_pii_contribution_type}
                                                onChange={(e) => handleTransferChange(e.target.value, index, 'swp_pii_contribution_type')}
                                            >
                                                {contributionTypeArray.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio sx={radioColorSx} />}
                                                        label={option.label} />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="swp_pii_fund_number" className='font15px'>Fund Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Fund Number"
                                            fullWidth
                                            size="small"
                                            name='swp_pii_fund_number'
                                            onChange={(e) => handleTransferChange(e.target.value, index, 'swp_pii_fund_number')}
                                            value={item.swp_pii_fund_number} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="swp_pii_fund_name" className='font15px'>Fund Name</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Fund Name"
                                            fullWidth
                                            size="small"
                                            name='swp_pii_fund_name'
                                            onChange={(e) => handleTransferChange(e.target.value, index, 'swp_pii_fund_name')}
                                            value={item.swp_pii_fund_name} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="swp_pii_gross_amount" className='font15px'>Gross Amount</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <NumberFormat
                                            customInput={TextField}
                                            prefix="$"
                                            allowNegative={false}
                                            label="Gross Amount"
                                            name="swp_pii_gross_amount"
                                            value={item.swp_pii_gross_amount}
                                            variant="outlined"
                                            thousandSeparator={true}
                                            size='small'
                                            fullWidth
                                            onValueChange={(values) => {
                                                handleTransferChange(values.value, index, 'swp_pii_gross_amount');
                                            }} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </Grid>
                            </React.Fragment>
                        ))}
                        <Button startIcon={<AddIcon />} onClick={() => addNewTemplate()}>
                            Add SWP Instruction
                        </Button>
                    </div>
                        <Grid container spacing={2} className='p-4'>
                            <Grid item xs={12}>
                                <Typography variant='h3' className='form-head-gray-title'>Pre-Authorization Contribution</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="dwp_frequency" className='font15px'>Frequency</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors && errors['swp_frequency'])}
                                >
                                    <InputLabel id="select-contact-application">Frequency</InputLabel>
                                    <Select
                                        labelId="select-contact-application"
                                        label="Frequency"
                                        value={swpDetails[0].swp_frequency || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedSwpDetails = [...swpDetails];
                                            updatedSwpDetails[0].swp_frequency = e.target.value; // Update the frequency in the swpDetails array
                                            setSwpDetails(updatedSwpDetails);
                                        }}
                                        inputProps={register('swp_frequency', {
                                            required: true
                                        })}
                                    >
                                        {pacFrequencyList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="pac-start-date" className='font15px'>Start Date</label>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <Stack spacing={3}>
                                        <Controller
                                            name="swp_start_date"
                                            control={control}
                                            rules={{
                                                required: 'Start date is required',
                                                validate: {
                                                    minDate: (value) =>
                                                        new Date(value) >= minDate || `Date must be after ${minDate.toISOString().split('T')[0]}`,
                                                    maxDate: (value) =>
                                                        new Date(value) <= maxDate || `Date must be before ${maxDate.toISOString().split('T')[0]}`,
                                                },
                                            }}
                                            render={({ field }) => (
                                                <DesktopDatePicker
                                                    label="Start Date"
                                                    inputFormat="yyyy/MM/dd"
                                                    value={field.value || null}
                                                    onChange={(newValue) => {
                                                        field.onChange(newValue); // Sync with react-hook-form
                                                        const updatedSwpDetails = [...swpDetails];
                                                        updatedSwpDetails[0].swp_start_date = newValue;
                                                        setSwpDetails(updatedSwpDetails);
                                                    }}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                            error={Boolean(errors.swp_start_date)}
                                                            helperText={errors.swp_start_date?.message}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>


                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="swp_account_option" className='font15px'>Account Option</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                >
                                    <InputLabel id="select-account-option">Account Option</InputLabel>
                                    <Select
                                        labelId="select-account-option"
                                        label="Account Option"
                                        value={swpDetails[0].swp_account_option || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedSwpDetails = [...swpDetails];
                                            updatedSwpDetails[0].swp_account_option = e.target.value; // Update the account option in the swpDetails array
                                            setSwpDetails(updatedSwpDetails);
                                        }}
                                        inputProps={register('swp_account_option', {
                                            required: true
                                        })}
                                    >
                                        {accountOptionArray.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>

                            {(swpDetails[0].swp_account_option == 1) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="swp_account-details" className='font15px'>Select Existing Investment Account</label>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors && errors['swp_investment_account_detail_id'])}
                                        >
                                            <InputLabel id="select-account-details">Investment Account</InputLabel>
                                            <Select
                                                labelId="select-account-details"
                                                label='Investment Account'
                                                value={swpDetails[0].swp_investment_account_detail_id || ''}
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={(e) => {
                                                    const updatedBankDetails = [...swpDetails];
                                                    updatedBankDetails[0].swp_investment_account_detail_id = e.target.value; // Update the account option in the swpDetails array
                                                    setSwpDetails(updatedBankDetails);
                                                }}
                                                inputProps={register('swp_investment_account_detail_id', {
                                                    required: true
                                                })}
                                            >
                                                {swpDetails[0].swp_investment_account_details.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </>}

                            {/* -------------banking details ----------- */}
                            {(swpDetails[0].swp_account_option == 2) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-name" className='font15px'>Account Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        >
                                            <InputLabel id="select-tpi-instruction_currency">Account Number</InputLabel>
                                            <Select
                                                labelId="select-tpi-instruction_currency"
                                                label="Account Number"
                                                value={selectedBankAccountNumber}
                                                classes={{ select: "custom-select-label" }}
                                                // name='instruction_currency'
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={handleBankAccountChange}
                                            >
                                                {transferDetails.map((detail) => (
                                                    <MenuItem key={detail.id} value={detail.bank_account_number}>
                                                        {detail.bank_account_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    {filteredAccountDetails?.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Name Of Bank"
                                                        fullWidth
                                                        InputLabelProps={item.bank_name ? { shrink: true } : {}}
                                                        size="small"
                                                        name='bank_name'
                                                        disabled
                                                        value={item.bank_name} />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Bank Transit Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_transit_number'
                                                        disabled
                                                        InputLabelProps={item.bank_transit_number ? { shrink: true } : {}}
                                                        value={item.bank_transit_number} />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>

                                                    <TextField
                                                        label="Institution Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_institution_number'
                                                        disabled
                                                        InputLabelProps={item.bank_institution_number ? { shrink: true } : {}}
                                                        value={item.bank_institution_number} />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>
                                            </React.Fragment>
                                        );
                                    })}
                                </>}
                        </Grid>
                    </>
                }

                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                            // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for Swp.
                            </Alert>
                        </Grid>
                    </div>
                }
                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form>
            {loader}
            <ToastContainer />
        </div>
    )
}

export default SwpInformation